/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Identifies if the service contact is a primary contact or not for an individual
 * @export
 * @enum {string}
 */
export enum ServiceContactIndividualType {
    Unknown = 'unknown',
    Primary = 'primary'
}


export function ServiceContactIndividualTypeFromJSON(json: any): ServiceContactIndividualType {
    return ServiceContactIndividualTypeFromJSONTyped(json, false);
}

export function ServiceContactIndividualTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceContactIndividualType {
    return json as ServiceContactIndividualType;
}

export function ServiceContactIndividualTypeToJSON(value?: ServiceContactIndividualType | null): any {
    return value as any;
}

